import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  &.bottom-to-top {
    background: linear-gradient(180deg, rgba(28, 28, 28, 0) 0%, rgba(28, 28, 28, 0.73) 100%);
    background: var(--t-brand-bg-gradient-mobile);
  }

  &.top-to-bottom {
    background: linear-gradient(0deg, rgba(28, 28, 28, 0) 0%, rgba(28, 28, 28, 0.73) 100%);
  }

  &.left-to-right {
    background: linear-gradient(270deg, rgba(28, 28, 28, 0) 0%, rgba(28, 28, 28, 0.73) 100%);
  }

  @media screen and (min-width: 992px) {
    &.bottom-to-top {
      background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0.03%, rgba(255, 255, 255, 0.46) 58%, rgba(255, 255, 255, 0.54) 100%);
      background: var(--t-brand-bg-gradient-desktop);
    }

    &.top-to-bottom {
      background: linear-gradient(90deg, rgba(28, 28, 28, 0) 0%, rgba(28, 28, 28, 0.73) 100%);
    }

    &.left-to-right {
      background: linear-gradient(270deg, rgba(28, 28, 28, 0) 0%, rgba(28, 28, 28, 0.73) 100%);
    }
  }
`;